import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const OrderTableService = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="OrderTableService" {...rest}>
      <path
        d="M12 7V18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.5 7H17.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M0 18H24"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.28 18L7.19 12.78C7.1392 12.5544 7.01179 12.3534 6.82946 12.2112C6.64714 12.069 6.42116 11.9944 6.19 12H3.08C2.84884 12.0056 2.62286 11.931 2.44054 11.7888C2.25821 11.6466 2.1308 11.4456 2.08 11.22L1 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M1.90991 18.29L2.99991 12.91C3.0446 12.6789 3.16939 12.4709 3.35231 12.3228C3.53523 12.1746 3.76455 12.0957 3.99991 12.1"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.72 18L16.81 12.78C16.8608 12.5544 16.9882 12.3534 17.1705 12.2112C17.3528 12.069 17.5788 11.9944 17.81 12H20.93C21.1611 12.0056 21.3871 11.931 21.5694 11.7888C21.7518 11.6466 21.8792 11.4456 21.93 11.22L23 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M22.09 18.29L21 12.91C20.9553 12.6789 20.8305 12.4709 20.6476 12.3228C20.4647 12.1746 20.2354 12.0957 20 12.1"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
};
